// extracted by mini-css-extract-plugin
module.exports = {"upload":"style_upload__31Be0","icon":"style_icon__mydw_","hidden":"style_hidden__1lMyP","buttons":"style_buttons__2Ts4s","trustdock":"style_trustdock__2x08U"};